import {Cookie} from "../utils/Cookie";

function generateCookie()
{
    const token = crypto.randomUUID();

    Cookie.setCookie("XSRF-TOKEN", token + ";secure;samesite=strict");

    return token;
}

function getCookie() {
    return Cookie.getCookie("XSRF-TOKEN")??""
}

export const XSRF = () => {
    return
}

XSRF.generateCookie = generateCookie;
XSRF.getCookie = getCookie;
